import React, { FC, HTMLAttributes, useCallback } from 'react';
import classNames from 'classnames';
import { IconButtonWrapper } from 'components/ui';
import styles from './FileInfo.module.scss';

export interface IFileInfo extends HTMLAttributes<HTMLDivElement> {
  filename: string;
  size: string;
  onRemove?: (event: any) => void;
  hasRemoveButton?: boolean;
}

const FileInfo: FC<IFileInfo> = (props) => {
  const { filename, size, onRemove = () => {}, className, hasRemoveButton = true } = props;
  const rootClassName = classNames(styles.root, className);

  const handleRemoveClick = useCallback(() => {
    onRemove('');
  }, [onRemove]);

  return (
    <div className={rootClassName}>
      <p className={styles.filename}>{filename}</p>
      <p className={styles.size}>{size} mb</p>
      {hasRemoveButton && (
        <IconButtonWrapper className={styles.button} onClick={handleRemoveClick} icon='trash-alt' />
      )}
    </div>
  );
};

export default FileInfo;
